let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cQXdw")).then(() => parcelRequire('eq6wD'));